export const LEAD_NEXT_ACTION_FOOTER = {
    label: 'Close',
    helper: 'Log an outcome to complete this task.',
};

export function deriveLeadNextActionFooter({ items, activeTreatmentId = null, isActive }) {
    const scopedItems = activeTreatmentId
        ? (items || []).filter((item) =>
            item.leadTreatment == null || String(item.leadTreatment) === String(activeTreatmentId)
        )
        : (items || []);
    // QUEUED is an in-flight completion state, not the next action the user can act on.
    const activeUpNextItem = scopedItems.find((item) => item.completion_state === 'OPEN') || null;
    const closesLeadNextAction = Boolean(isActive && activeUpNextItem?.item_type === 'LEAD_NEXT_ACTION');

    return {
        activeUpNextItem,
        closesLeadNextAction,
        label: closesLeadNextAction ? LEAD_NEXT_ACTION_FOOTER.label : '',
        helper: closesLeadNextAction ? LEAD_NEXT_ACTION_FOOTER.helper : '',
    };
}
